import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-4007">
      <section className="py-16 bg-white" data-id="element-4008">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4009">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-4010">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-4011">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-4012">
            {/* Main Pages */}
            <div data-id="element-4013">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4014">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4015">
                <li data-id="element-4016">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4017">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-4018">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4019">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-4020">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4021">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-4022">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4023">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-4024">
                <li data-id="element-4025">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4026">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-4027">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4028">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-4029">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4030">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-4031">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4032">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-4033">
                <li data-id="element-4034">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4035">
                    All Services
                  </Link>
                </li>
                <li data-id="element-4036">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4037">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-4038">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4039">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-4040">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4041">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-4042">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4043">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-4044">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4045">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-4046">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4047">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-4048">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4049">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-4050">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4051">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-4052">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4053">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-4054">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4055">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4056">
                <li data-id="element-4057">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4058">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-4059">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4060">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-4061">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4062">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-4063">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4064">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-4065">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4066">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-4067">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4068">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-4069">
                <li data-id="element-4070">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4071">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-4072">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4073">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-4074">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4075">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-4076">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4077">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-4078">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4079">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-4080">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4081">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-4082">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4083">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-4084">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4085">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-4086">
                <li data-id="element-4087">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4088">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-4089">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4090">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-4091">
                <li data-id="element-4092">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4093">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-4094">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4095">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-4096">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4097">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-4098">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-4099">
              <div className="flex items-center gap-2" data-id="element-4100">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-4101" />
                <span data-id="element-4102">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-4103">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4104">
                <Button size="sm" className="gap-2" data-id="element-4105">
                  <Calendar className="w-4 h-4" data-id="element-4106" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-4107">
                <Button variant="whatsapp" size="sm" className="gap-2" data-id="element-4108">
                  <MessageCircle className="w-4 h-4" data-id="element-4109" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-4110">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-4111">
                  <Phone className="w-4 h-4" data-id="element-4112" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}